export default {"src":"/_next/static/media/team-placeholder.7b8462f8.svg","height":88,"width":88};